/**
 * Copyright (c) 2021, Ouster, Inc.
 * All rights reserved.
 */
import { Shortcut } from '@ouster/webviz-react-components';

import { action, Action as EzPzAction } from 'easy-peasy';

/// ///////////////////////////////////////////////////////////////////////////
// State and Model
/// ///////////////////////////////////////////////////////////////////////////

export type State = {
  shortcuts: Shortcut[];
  // Useful to know if CTRL should be treated as CMD
  isMac: boolean;
};

export const defaultState: State = {
  shortcuts: [],
  isMac: navigator.platform.toUpperCase().indexOf('MAC') >= 0,
};

export interface ShortcutStateModel extends State {
  addShortcut: EzPzAction<ShortcutStateModel, Shortcut>;
}

export const model: ShortcutStateModel = {
  ...defaultState,
  addShortcut: action((state, newShortcut) => {
    // If the keys are exactly the same, treat this as an override of
    // the shortcut action
    const alreadyHasShortcut = state.shortcuts.some((shortcut) =>
      shortcut.sharesKeysWith(newShortcut)
    );

    // State updates in easy-peasy are immutable so we don't worry about
    // the copy here
    let newShortcuts = [...state.shortcuts];
    if (alreadyHasShortcut) {
      // If the shortcut already exists, keep the original ordering of
      // the shortcuts in the array so they don't move around in the
      // cheatsheet
      newShortcuts = newShortcuts.map((shortcut) => {
        if (shortcut.sharesKeysWith(newShortcut)) {
          return newShortcut;
        }
        return shortcut;
      });
    } else {
      newShortcuts.push(newShortcut);
    }

    state.shortcuts = newShortcuts;
  }),
};
